import api from "~/api/api";
import type {ListInterface} from "~/api/interfaces/ListInterface";
import {Order as OrderEntity} from "~/dto/order/Order";

export class Order {

    static async createOrder(formData: FormData): Promise<Object> {
        return api("/orders/make", formData, "POST");
    }

    static async getMyOrders(): ListInterface<OrderEntity> {
        const data = await api("/orders/my");
        return {
            count: data.count,
            items: data.orders.map(el => OrderEntity.createFromObj(el)),
        }
    }

}